/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { InvalidContext } from "cms/common/errors/invalid-context.error";
import { useContext } from "react";
import { AllCollapsedContext } from "./all-collapsed.context";

export function useAllCollapsed () {

    const context = useContext(AllCollapsedContext);

    if (!context) {
        throw new InvalidContext("AllCollapsedContext", "AllCollapsedProvider");
    }

    return context;
}

